import icon_close from "./../svg/x_white.svg";

const ICON_CLOSE = ({ className = "", color = "black", size }) => {
  const iconSize = !isNaN(size) ? Number(size) : 20;

  return (
    <div
      className={`rounded_full center_perfect ${className}`}
      style={{
        height: `${iconSize}px`,
        width: `${iconSize}px`,
        background: color,
      }}
    >
      <img src={icon_close} width={`${iconSize / 2}px`} alt="close" />
    </div>
  );
};

export default ICON_CLOSE;
